import { contract } from './contract';

export const str = contract<string>('string');
